import { useEffect, useReducer } from 'react';

import LoginPopup from '@/legacy/components/user/twoFactorAuthentication/loginPopupTwoFactor/root/presentation/LoginPopup.bindings';
import TwoFactorSetupDialog from '@/legacy/components/user/twoFactorAuthentication/TwoFactorSetupDialog/TwoFactorSetupDialog';

import {
  ActionType,
  getInitialState,
  handleQueries,
  LoginCallbacks,
  reducer,
  State,
} from './SessionTimeout.reducer';
import SessionTimeoutDialog from './SessionTimeoutDialog';

interface Props extends LoginCallbacks {
  email: string;
}

const SessionTimeoutFragment = (props: Props): React.JSX.Element => {
  const { email } = props;

  const initialState = getInitialState({
    email,
  });

  const [state, dispatch] = useReducer(reducer, initialState);

  // We'll pass down state without queries so we don't re-render if queries change
  const { queries, ...stateWithoutQueries } = state;

  useEffect(
    () => {
      handleQueries(queries, dispatch, props);
      /**
       * Queries need to be cleared so that it's safe to call handleQueries multiple times.
       * @todo (Mark) investigate this.
       */
    },
    // Intentionally only run this effect when state.queries changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [queries]
  );

  // @todo add useCallbacks here

  const handleLogout = () => {
    dispatch({
      type: ActionType.Logout,
    });
  };

  const handleSubmit = () => {
    dispatch({
      type: ActionType.SubmitForm,
    });
  };

  const handleChangePassword = (password: string) => {
    dispatch({
      type: ActionType.UpdatePassword,
      payload: password,
    });
  };

  const handleCloseTwoFactorCodePopup = () => {
    dispatch({
      type: ActionType.CloseTwoFactorCodeDialog,
      payload: { isSuccessful: false },
    });
  };

  const handleSuccessfulTwoFactorChallenge = () => {
    dispatch({
      type: ActionType.CloseTwoFactorCodeDialog,
      payload: { isSuccessful: true },
    });
  };

  const handleCloseSignupDialog = () => {
    dispatch({
      type: ActionType.CloseTwoFactorSignupDialog,
    });
  };

  return (
    <>
      <SessionTimeoutDialog
        state={stateWithoutQueries as State}
        isOpen
        onLogout={handleLogout}
        onSubmit={handleSubmit}
        onChangePassword={handleChangePassword}
      />
      <LoginPopup
        onClose={handleCloseTwoFactorCodePopup}
        onSuccessfulTwoFactorChallenge={handleSuccessfulTwoFactorChallenge}
        isOpen={state.isTwoFactorCodePopupOpen}
      />
      <TwoFactorSetupDialog
        isOpen={state.isTwoFactorSignupOpen}
        onClose={handleCloseSignupDialog}
      />
    </>
  );
};

export default SessionTimeoutFragment;
